export function resolveActiveOrganizationId(input: {
  selectedOrganizationId: string | null | undefined;
  activeProjectId: string | null | undefined;
  orgProjects: Array<{ projectId?: string; organizationId?: string }>;
  organizations: Array<{ id?: string }>;
}): string | null {
  const selectedOrgId = input.selectedOrganizationId;
  if (selectedOrgId) return selectedOrgId;
  const projectId = input.activeProjectId;
  if (!projectId) return input.organizations?.[0]?.id ?? null;
  const mapping = input.orgProjects?.find((entry) => entry.projectId === projectId) ?? null;
  return mapping?.organizationId ?? input.organizations?.[0]?.id ?? null;
}
